import request from '@/utils/request'

export function queryComReportDetail(params) {
  return request({
    url: 'api/v1/com/query',
    method: 'get',
    params: params
  })
}

export function hitQuery(params) {
  return request({
    url: 'api/v1/com/hit',
    method: 'get',
    params: params
  })
}

export function queryReportPackageList() {
  return request({
    url: 'api/v1/feepackage/rp/list',
    method: 'get',
  })
}

export function queryOrderDetail(params, name) {
  return request({
    url: name === 'certificatePayResult' ? 'api/v1/plaque/pay/certificate/order/detail' : 'api/v1/pay/report/order/detail',
    method: 'get',
    params: params
  })
}

export function doAdaPay(data) {
  return request({
    url: '/api/v1/pay/report/adapay',
    method: 'post',
    data: data
  })
}

export function doAlipay(data) {
  return request({
    url: 'api/v1/pay/report/alipay',
    method: 'post',
    data: data
  })
}
export function doWepay(data) {
  return request({
    url: 'api/v1/pay/report/wepay',
    method: 'post',
    data: data
  })
}

export function checkCoupon(params, model) {
  const urlMap = {
    report: 'api/v1/pay/getIsPayInfo',
    certificate: 'api/v1/plaque/pay/getIsPayInfo'
  }
  return request({
    url: urlMap[model],
    method: 'get',
    params,
  })
}

export function saveInfo(data) {
  return request({
    url: 'api/v1/pay/saveDetail',
    method: 'post',
    data,
  })
}

//注销支付宝支付
export function aliAdapay(data) {
  return request({
    url: '/api/v1/pay/qyzx/ali/adapay',
    method: 'post',
    data,
  })
}

//注销微信支付
export function adapayWx(data) {
  return request({
    url: '/api/v1/pay/qyzx/wx/adapay',
    method: 'post',
    data: data
  })
}

//经营异常支付宝支付
export function ycAliAdapay(data) {
  return request({
    url: '/api/v1/pay/jyyc/ali/adapay',
    method: 'post',
    data,
  })
}

//经营异常微信支付
export function ycAdapayWx(data) {
  return request({
    url: '/api/v1/pay/jyyc/wx/adapay',
    method: 'post',
    data: data
  })
}

//套餐列表
export function getPackageList(data) {
  return request({
    url: '/api/v1/feepackage/tc/list',
    method: 'get',
    params: data
  })
}

//微信
export function wxAdapay(data) {
  return request({
    url: '/api/v1/pay/wx/adapay',
    method: 'post',
    data
  })
}

//新平台套餐列表获取
export function getGroundList(data) {
  return request({
    url: 'oc/feePackage/groundList',
    method: 'post',
    data
  })
}
//新平台支付
export function payAddOrder(data) {
  return request({
    url: 'oc/adapay/wxUrlScheme',
    method: 'post',
    data
  })
}


export function burialPoint(data) {
  return request({
    url: 'sms/burialPoint',
    method: 'post',
    data
  })
}
//新平台支付宝
export function payAdapay(data) {
  return request({
    url: 'oc/adapay/AliPayUrlScheme',
    method: 'post',
    data
  })
}


//获取支付方式
export function payAllList(data) {
  return request({
    url: '/oc/paymethod/findPayMethod',
    method: 'post',
    data
  })
}

//跳转小程序
export function wxUrlSchema(data) {
  return request({
    url: 'oc/adapay/wxUrlScheme',
    method: 'post',
    data,
  })
}

//获取数据
export function findH5Config(data) {
  return request({
    url: 'sms/findH5Config',
    method: 'post',
    data,
  })
}

export function ConfirmStatus(data) {
  return request({
    url: '/sms/ConfirmStatus',
    method: 'post',
    data,
  })
}

//投诉
export function complaint(data) {
  return request({
    url: 'oc/complaint/complaintH5',
    method: 'post',
    data
  })
}

//获取验证码
export function agreeApply(data) {
  return request({
    url: 'oc/unionPay/agreeApply',
    method: 'post',
    data
  })
}

//下一步确认
export function agreeCofirn(data) {
  return request({
    url: 'oc/unionPay/agreeCofirn',
    method: 'post',
    data
  })
}

//支付确认
export function payConfirm(data) {
  return request({
    url: 'oc/unionPay/payConfirm',
    method: 'post',
    data
  })
}

//重新获取验证码
export function paySms(data) {
  return request({
    url: 'oc/unionPay/paySms',
    method: 'post',
    data
  })
}

export function findOrder(data) {
  return request({
    url: 'oc/private/findOrder',
    method: 'post',
    data
  })
}

export function lianLianBank(data) {
  return request({
    url: 'oc/unionPay/lianLianBank',
    method: 'post',
    data
  })
}





